const StudioIcon = () => (
  <>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      color="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6331 7.5V5.83333H14.1331V2.5H15.7998V5.83333H18.2998V7.5H11.6331ZM14.1331 17.5V9.16667H15.7998V17.5H14.1331ZM5.7998 17.5V14.1667H3.2998V12.5H9.96647V14.1667H7.46647V17.5H5.7998ZM5.7998 10.8333V2.5H7.46647V10.8333H5.7998Z"
        fill="inherit"
      />
    </svg>
  </>
);

export default StudioIcon;
